var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{on:{"click":_vm.openTermOfUse}},[_vm._v("Hinweise und Nutzungsbedingen - "+_vm._s(_vm.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }